(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  var previewInput = document.getElementById('typeface-preview-input');
  var articles = document.querySelectorAll('article[data-product-id]');

  function getPreview(article) {
    return article.querySelector('.typeface-preview');
  }

  function getCheckedInput(article) {
    return article.querySelector('input[type="radio"]:checked');
  }

  // 'OK GKS' + 'Semi Bold' -> 'OK GKS Semi Bold'
  // Doubles as the preview text and the @font-face family name (see snippets/font-loader.liquid)
  function buildText(article, style) {
    var base = article.dataset.productTitle;
    return style ? base + ' ' + style : base;
  }

  function applyFont(article, preview, style) {
    preview.style.fontFamily = "'" + buildText(article, style) + "'";
  }

  articles.forEach(function (article) {
    var preview = getPreview(article);
    var radioGroup = article.querySelector('[role="radiogroup"]');
    if (!radioGroup) return;

    radioGroup.querySelectorAll('label').forEach(function (label) {
      var input = label.querySelector('input[type="radio"]');
      var style = input ? input.value : '';

      label.addEventListener('mouseenter', function () {
        applyFont(article, preview, style);
        if (!previewInput || previewInput.value === '') {
          preview.textContent = buildText(article, style);
        }
      });

      label.addEventListener('mouseleave', function () {
        var checked = getCheckedInput(article);
        var cur = checked ? checked.value : '';
        applyFont(article, preview, cur);
        if (!previewInput || previewInput.value === '') {
          preview.textContent = buildText(article, cur);
        }
      });

      if (input) {
        input.addEventListener('change', function () {
          preview.dataset.default = buildText(article, style);
          applyFont(article, preview, style);
          if (!previewInput || previewInput.value === '') {
            preview.textContent = preview.dataset.default;
          }
        });
      }
    });
  });

  if (previewInput) {
    previewInput.addEventListener('input', function () {
      var val = this.value.replace(/\r/g, '');
      articles.forEach(function (article) {
        var preview = getPreview(article);
        var checked = getCheckedInput(article);
        var cur = checked ? checked.value : '';
        preview.textContent = val || preview.dataset.default;
        applyFont(article, preview, cur);
      });
    });
  }

  // ── Mobile filter bar toggle ──────────────────────────────────
  var filterToggle = document.getElementById('collection-filter-toggle');
  var filterToggleLabel = document.getElementById('collection-filter-toggle-label');
  var filterPanel = document.getElementById('collection-filter-panel');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () {
      var open = filterPanel.classList.contains('hidden');
      filterPanel.classList.toggle('hidden', !open);
      filterPanel.classList.toggle('flex', open);
      filterToggle.setAttribute('aria-expanded', String(open));
      if (filterToggleLabel) filterToggleLabel.textContent = open ? 'close' : 'options';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // ── Consent checkbox ────────────────────────────────────────
  var consentLabel = document.getElementById('footer-consent-label');
  var consentCb = document.getElementById('footer-consent');
  var consentCheck = document.getElementById('footer-consent-check');
  var submitBtn = document.getElementById('footer-subscribe-btn');

  if (consentLabel) {
    consentLabel.addEventListener('click', function (e) {
      // Let the privacy-policy link inside the label navigate instead of
      // toggling the checkbox.
      if (e.target.closest('a')) return;

      e.preventDefault();
      consentCb.checked = !consentCb.checked;
      consentCheck.classList.toggle('hidden', !consentCb.checked);
      if (submitBtn) submitBtn.disabled = !consentCb.checked;
    });
  }

  // ── Weather ─────────────────────────────────────────────────
  var isNight = (function () {
    var h = new Date().getHours();
    return h < 6 || h >= 20;
  })();

  var WMO = {
    0: { g: isNight ? '' : '', d: 'clear sky' },
    1: { g: isNight ? '' : '', d: 'mainly clear' },
    2: { g: isNight ? '' : '', d: 'partly cloudy' },
    3: { g: '', d: 'overcast' },
    45: { g: '', d: 'fog' },
    48: { g: '', d: 'icy fog' },
    51: { g: '', d: 'light drizzle' },
    53: { g: '', d: 'drizzle' },
    55: { g: '', d: 'heavy drizzle' },
    61: { g: '', d: 'light rain' },
    63: { g: '', d: 'rain' },
    65: { g: '', d: 'heavy rain' },
    71: { g: '', d: 'light snow' },
    73: { g: '', d: 'snow' },
    75: { g: '', d: 'heavy snow' },
    77: { g: '', d: 'snow grains' },
    80: { g: isNight ? '' : '', d: 'rain showers' },
    81: { g: isNight ? '' : '', d: 'rain showers' },
    82: { g: isNight ? '' : '', d: 'heavy showers' },
    85: { g: '', d: 'snow showers' },
    86: { g: '', d: 'snow showers' },
    95: { g: '', d: 'thunderstorm' },
    96: { g: '', d: 'thunderstorm' },
    99: { g: '', d: 'thunderstorm' },
  };

  var iconEl = document.getElementById('footer__weather-icon');
  var tempEl = document.getElementById('footer__weather-temp');
  var descEl = document.getElementById('footer__weather-desc');
  var cityEl = document.getElementById('footer__weather-city');

  if (!iconEl) return;

  // IP-based lookup (ipwho.is) instead of navigator.geolocation — avoids
  // the browser's location permission prompt and also gives us city/country
  // directly, so no separate reverse-geocoding call is needed. Picked over
  // ipapi.co, which 429s quickly on its free tier — ipwho.is has no
  // published rate limit and needs no API key.
  fetch('https://ipwho.is/')
    .then(function (r) {
      return r.json();
    })
    .then(function (geo) {
      var lat = geo.latitude;
      var lon = geo.longitude;
      if (typeof lat !== 'number' || typeof lon !== 'number') return;

      var weatherUrl =
        'https://api.open-meteo.com/v1/forecast' +
        '?latitude=' +
        lat +
        '&longitude=' +
        lon +
        '&current=temperature_2m,weather_code' +
        '&timezone=auto';

      return fetch(weatherUrl)
        .then(function (r) {
          return r.json();
        })
        .then(function (weather) {
          var code = weather.current.weather_code;
          var temp = Math.round(weather.current.temperature_2m);
          var info = WMO[code] || WMO[Math.floor(code / 10) * 10] || { g: '?', d: 'unknown' };

          var city = geo.city || geo.region || '';
          var country = geo.country || '';

          if (iconEl) iconEl.textContent = info.g;
          if (tempEl) tempEl.textContent = temp + '°C';
          if (descEl) descEl.textContent = info.d;
          if (cityEl) cityEl.textContent = city + (country ? ', ' + country : '');
        });
    })
    .catch(function () {
      if (descEl) descEl.textContent = 'weather unavailable';
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  var els = document.querySelectorAll('[data-header-clock]');

  if (els.length) {
    var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    var months = [
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december',
    ];

    function ordinal(n) {
      var s = ['th', 'st', 'nd', 'rd'];
      var v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }

    function pad(n) {
      return n < 10 ? '0' + n : n;
    }

    function tick() {
      var now = new Date();
      var offset = now.getTimezoneOffset();
      var sign = offset <= 0 ? '+' : '-';
      var gmt = 'gmt' + sign + Math.floor(Math.abs(offset) / 60);
      var time = pad(now.getHours()) + ':' + pad(now.getMinutes()) + ':' + pad(now.getSeconds());

      var desktopText =
        days[now.getDay()] +
        ' ' +
        months[now.getMonth()] +
        ' ' +
        ordinal(now.getDate()) +
        ', ' +
        now.getFullYear() +
        ' at ' +
        time +
        ' ' +
        gmt;
      var mobileText =
        now.getFullYear() +
        '. ' +
        pad(now.getMonth() + 1) +
        '. ' +
        pad(now.getDate()) +
        ' (' +
        days[now.getDay()].slice(0, 3) +
        ') ' +
        time +
        ' ' +
        gmt;

      els.forEach(function (el) {
        el.textContent = el.dataset.headerClock === 'desktop' ? desktopText : mobileText;
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  // Mobile menu toggle
  var toggle = document.getElementById('mobile-menu-toggle');
  var toggleLabel = document.getElementById('mobile-menu-toggle-label');
  var panel = document.getElementById('mobile-menu-panel');
  var siteHeader = document.getElementById('site-header');
  var iconOpen = document.getElementById('mobile-menu-icon-open');
  var iconClose = document.getElementById('mobile-menu-icon-close');
  if (toggle && panel) {
    // The panel appears and disappears outright — nothing to animate here.
    function setOpen(open) {
      toggle.dataset.open = String(open);
      toggle.setAttribute('aria-expanded', String(open));
      panel.classList.toggle('hidden', !open);
      panel.classList.toggle('flex', open);
      if (siteHeader) siteHeader.style.backgroundColor = open ? 'var(--color-grey-100)' : '';
      if (toggleLabel) toggleLabel.textContent = open ? 'close' : 'menu';
      if (iconOpen) iconOpen.classList.toggle('hidden', open);
      if (iconClose) iconClose.classList.toggle('hidden', !open);

      // Only lift the body scroll lock if no other modal (e.g. the cart
      // drawer) is still open.
      var cartModal = document.getElementById('cart-modal');
      var cartOpen = cartModal && !cartModal.classList.contains('hidden');
      document.body.style.overflow = open || cartOpen ? 'hidden' : '';
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.dataset.open !== 'true');
    });

    document.addEventListener('click', function (e) {
      if (toggle.dataset.open !== 'true') return;
      if (toggle.contains(e.target) || panel.contains(e.target)) return;
      setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    // Avoid a stuck-open panel if the viewport grows past `pc` while open.
    var pcQuery = window.matchMedia('(min-width: 1024px)');
    pcQuery.addEventListener('change', function (e) {
      if (e.matches) setOpen(false);
    });
  }

  // ── Sticky bar stack ─────────────────────────────────────────
  // A sticky element's `top` resolves against the scrollport, never
  // against an ancestor, so bars can't stack themselves in CSS. Instead
  // every [data-sticky-bar] is measured here and given a `top` that
  // clears the bars before it in document order; the running total is
  // published as --sticky-top for the page content below (input.css).
  // Marking a new bar is the only edit adding one needs.
  var headerGroup = document.querySelector('.shopify-section-group-header-group');
  var headerHidden = false;

  // Shopify generates the header group wrapper, so it can't carry the
  // attribute in markup and opts in here instead.
  if (headerGroup) headerGroup.dataset.stickyBar = '';
  var stickyBars = document.querySelectorAll('[data-sticky-bar]');

  function layoutStickyBars() {
    var offset = 0;
    var fullHeight = 0;

    stickyBars.forEach(function (bar) {
      // A hiding header parks itself just off the top of the screen and
      // stops taking room in the stack, so the bars under it — and the
      // page content under them — ride up to fill it.
      var hiding = bar === headerGroup && headerHidden;

      bar.style.top = (hiding ? -bar.offsetHeight : offset) + 'px';
      fullHeight += bar.offsetHeight;
      if (!hiding) offset += bar.offsetHeight;
    });

    var root = document.documentElement.style;
    root.setProperty('--sticky-top', offset + 'px');

    // The stack at full height, ignoring whether the header happens to be
    // hidden right now. Anchor targets clear themselves by this so they
    // don't end up behind a header that reappears on the way up.
    root.setProperty('--sticky-top-max', fullHeight + 'px');

    // Tracked separately: the mobile menu panel is positioned and sized
    // from the header's real height whether or not it's on screen.
    if (headerGroup) {
      root.setProperty('--header-height', headerGroup.offsetHeight + 'px');
    }
  }

  if (stickyBars.length) {
    // Fires once per element on observe, so this also does the first layout.
    var barObserver = new ResizeObserver(layoutStickyBars);
    stickyBars.forEach(function (bar) {
      barObserver.observe(bar);
    });
  }

  // ── Hide on scroll down, reveal on scroll up ─────────────────
  // The sticky wrapper (not <header> itself) is what slides: leaving an
  // invisible full-width strip stuck at the top would keep swallowing
  // clicks meant for the content behind it. Flipping the flag is all this
  // has to do — the stack layout above reads it and moves everything.
  if (headerGroup) {
    var lastScrollY = window.scrollY;
    var scrollTicking = false;

    function setHeaderHidden(hidden) {
      if (hidden === headerHidden) return;
      headerHidden = hidden;
      layoutStickyBars();
    }

    function updateHeaderVisibility() {
      var y = Math.max(window.scrollY, 0);
      var delta = y - lastScrollY;

      // Sub-pixel scrolls and trackpad/rubber-band jitter would otherwise
      // flip the header back and forth on a single gesture.
      if (Math.abs(delta) < 5) return;
      lastScrollY = y;

      // The mobile panel hangs off the header's bottom edge, so the header
      // has to stay put while it's open. Near the top there's nothing to
      // gain by hiding, and the header would re-appear a few pixels into
      // any upward scroll anyway.
      var menuOpen = toggle && toggle.dataset.open === 'true';
      if (menuOpen || y <= headerGroup.offsetHeight) {
        setHeaderHidden(false);
        return;
      }

      setHeaderHidden(delta > 0);
    }

    window.addEventListener(
      'scroll',
      function () {
        if (scrollTicking) return;
        scrollTicking = true;
        requestAnimationFrame(function () {
          updateHeaderVisibility();
          scrollTicking = false;
        });
      },
      { passive: true },
    );

    // Tabbing into the header (or an anchor jump landing in it) must not
    // leave focus on something the user can't see.
    headerGroup.addEventListener('focusin', function () {
      setHeaderHidden(false);
    });
  }

  // Home icon: the static mark is the animation's first frame, so the Lottie
  // can take over on hover and be dropped back to frame 0 on hover out.
  var homeMount = document.querySelector('[data-home-lottie]');
  var canAnimate =
    window.matchMedia('(hover: hover)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (homeMount && canAnimate) {
    var homeLink = homeMount.closest('a');
    var homeIcon = homeMount.parentElement.querySelector('svg');
    var homeAnim = null;
    var homeHovered = false;
    var homePending = false;

    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var el = document.createElement('script');
        el.src = src;
        el.onload = resolve;
        el.onerror = reject;
        document.head.appendChild(el);
      });
    }

    function loadHomeAnimation() {
      if (homePending) return;
      homePending = true;

      Promise.all([loadScript(homeMount.dataset.playerSrc), loadScript(homeMount.dataset.animationSrc)])
        .then(function () {
          homeAnim = window.lottie.loadAnimation({
            container: homeMount,
            renderer: 'svg',
            loop: true,
            autoplay: false,
            animationData: window.openboekHomeLottie,
            // The artwork sits in a 1080 canvas with more padding than the
            // static SVG has; cropping it keeps both at the same optical size.
            rendererSettings: { viewBoxSize: '37 37 1007 1007' },
          });
          homeIcon.style.visibility = 'hidden';
          if (homeHovered) homeAnim.goToAndPlay(0, true);
        })
        .catch(function () {
          homePending = false;
        });
    }

    homeLink.addEventListener('pointerenter', function () {
      homeHovered = true;
      if (homeAnim) homeAnim.goToAndPlay(0, true);
      else loadHomeAnimation();
    });

    homeLink.addEventListener('pointerleave', function () {
      homeHovered = false;
      if (homeAnim) homeAnim.goToAndStop(0, true);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-clothing"]) return;
  try {
    
  var variantsEl = document.getElementById('clothing-variants-json');
  if (!variantsEl) return;
  var variants = JSON.parse(variantsEl.textContent);

  var map = {};
  variants.forEach(function (v) {
    map[v.option1] = v.id;
  });
  window.__clothingVariants = map;

  var select = document.getElementById('clothing-size-select');
  var idInput = document.getElementById('clothing-variant-id');
  if (select && idInput && map[select.value]) {
    idInput.value = map[select.value];
  }

  var form = idInput && idInput.closest('form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = idInput.value;
      if (!variantId) return;
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: 'cart-drawer',
        }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (response) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(function (err) {
          console.error('[cart/add]', err);
        })
        .finally(function () {
          if (btn) btn.disabled = false;
        });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var el = document.getElementById('product-recommendations');
  if (!el) return;

  fetch(el.dataset.url)
    .then(function (r) {
      return r.text();
    })
    .then(function (html) {
      var div = document.createElement('div');
      div.innerHTML = html;
      var inner = div.querySelector('#product-recommendations');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    })
    .catch(function (e) {
      console.error(e);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-faq"] && !Shopify.designMode) return;
  try {
    
  function activate(tabs, tab) {
    tabs.forEach(function (t) {
      t.classList.remove('bg-grey-400');
      t.classList.add('bg-grey-200');
    });
    tab.classList.add('bg-grey-400');
    tab.classList.remove('bg-grey-200');
  }

  document.querySelectorAll('[data-faq-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var scope = tab.closest('section');
      var tabs = scope.querySelectorAll('[data-faq-tab]');
      activate(Array.prototype.slice.call(tabs), tab);
      var cat = tab.dataset.faqTab;
      scope.querySelectorAll('[data-faq-item]').forEach(function (item) {
        var show = cat === '' || item.dataset.faqItem === cat;
        item.classList.toggle('hidden', !show);
      });
    });
  });

  document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-faq-item]');
      var answer = item.querySelector('[data-faq-answer]');
      var arrow = btn.querySelector('[data-faq-arrow]');
      var hidden = answer.classList.toggle('hidden');
      if (arrow) arrow.textContent = hidden ? '↓' : '↑';
      btn.setAttribute('aria-expanded', String(!hidden));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-license"] && !Shopify.designMode) return;
  try {
    
  // Remember which tab was active per section instance, so that when
  // the theme editor re-renders this section (e.g. right after any
  // setting change inside a tab) the user isn't silently bounced back
  // to the first tab — a plain "run once on load" activation would
  // otherwise make whatever you were editing appear to vanish, since
  // the re-rendered panel reverts to its Liquid-authored default
  // ("hidden") until something re-activates it.
  var activeTabBySection = {};

  function init(tablist) {
    var scope = tablist.closest('section');
    var sectionEl = tablist.closest('[id^="shopify-section-"]') || scope;
    var sectionId = sectionEl.id || 'default';

    // Each license-tab block renders its own button next to its panel;
    // move the buttons here (in block order) to form the tab row.
    var buttons = scope.querySelectorAll('[data-license-tab-button]');
    buttons.forEach(function (btn) {
      tablist.appendChild(btn);
    });

    var tabs = tablist.querySelectorAll('[data-license-tab]');
    var panels = scope.querySelectorAll('[data-license-panel]');
    if (!tabs.length || !panels.length) return;

    function activate(tab) {
      tabs.forEach(function (t) {
        t.classList.remove('bg-black', 'text-white');
        t.classList.add('bg-grey-100');
      });
      tab.classList.add('bg-black', 'text-white');
      tab.classList.remove('bg-grey-100');

      panels.forEach(function (p) {
        var isHidden = p.dataset.licensePanel !== tab.dataset.licenseTab;
        // Shopify wraps each license-tab instance in its own
        // ".shopify-block" div, which is what the section's
        // `flex flex-col gap-5` actually treats as the flex item —
        // hiding only the inner panel leaves that wrapper (now empty)
        // still taking its share of gap. Hide the wrapper too so an
        // inactive tab doesn't add an extra gap.
        var wrapper = p.closest('.shopify-block') || p;
        wrapper.classList.toggle('hidden', isHidden);
        p.classList.toggle('hidden', isHidden);
      });

      activeTabBySection[sectionId] = tab.dataset.licenseTab;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab);
      });
    });

    var rememberedId = activeTabBySection[sectionId];
    var toActivate = tabs[0];
    if (rememberedId) {
      var match = tablist.querySelector('[data-license-tab="' + rememberedId + '"]');
      if (match) toActivate = match;
    }
    activate(toActivate);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-license-tablist]').forEach(init);
  }

  initAll();

  // Re-run whenever the editor reloads a section (e.g. right after a
  // setting change anywhere inside it, including nested blocks).
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
